export default __webpack_public_path__ + "static/media/link.646237c6.svg";